import { render } from "./Leads.vue?vue&type=template&id=6ce5c466"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"

import exportComponent from "/home/crm/ganarcrm_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__